import { getLocaleLanguage } from './init';

export default async function selectTranslation () {    
    const env = this.env;
    let locale = getLocaleLanguage();
    if ( this.widget?.language && this.widget?.language !== 'auto') {
        locale = this.widget?.language;
    }
    this.locale = locale;

    if (env.errorsStore?.error?.code === 'INVALID_API_KEY') {
        await env.languageStore.getStaticTranslations();
    } else {
        await env.languageStore.getTranslations();
    }
}
